import { resolveHeaderMapping, unmappedFieldIds } from './csv-header-mapping';
import { downloadItemCsvTemplate } from './item-csv-template';
import {
  CsvRequiredColumn,
  CsvRowProblemGroup,
  describeCsvItem,
  findCsvRowProblems,
  formatCsvRowList,
  groupCsvRowProblems,
  truncateCsvValue,
  CSV_PRICE_PATTERN,
  isMissingCsvValue,
} from './csv-row-problems';
import { decodeCsvBytes } from './csv-decode';
import { importChargeConfirmation, isFreeFirstImport, isUploadChargeRefusal } from './import-charge-confirm';
import { ImportChargeConfirmDialogComponent } from './import-charge-confirm-dialog.component';
import { ImportFreeFirstDialogComponent } from './import-free-first-dialog.component';
import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Inject,
  OnDestroy,
  SimpleChanges,
  OnChanges,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ContactService } from 'src/app/pages/contacts/services/contact.service';
import { ComSerService } from '../../commanservice/com-ser.service';
import { io } from 'socket.io-client';
import { environment } from 'src/environments/environment';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import * as Papa from 'papaparse';
import { Subject, Subscription, finalize, take } from 'rxjs';
import { ItemsService } from 'src/app/pages/items/services/items.service';
import {
  ModalComponent,
  ModalModel,
} from '../../components/modal/modal.component';
import { UploadImagesPreviewModelComponent } from '../upload-images-preview/upload-images-preview.component';
import { SocketService } from '../../socket/socketio.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-upload-csv',
    templateUrl: './upload-csv.component.html',
    styleUrls: ['./upload-csv.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class UploadCsvComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  downloadcsv = environment.API_URL + '/assets/osmos_contactcsv.csv';

  // table

  // @ViewChild('singleSelect') searching: ElementRef;
  // wareHouseSearch: FormControl = new FormControl();
  // public c: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  showData: any = [];
  headingdata: any = [];
  csvAllKey: any = [];
  index: number = 1;
  fileUploading: any;
  allcsvlisting: any = [];
  emailInsert = [];
  emailcheckeking = [];
  itemsCsvFile: any;
  dataarryCsc = [];
  csvFile = new FormControl('');

  csvform: FormGroup;
  emaildata = [];
  sub: boolean = false;
  showCsvDropdown: boolean = false;
  selectItem: any = {};
  records: any;
  /**
   * Card #536: one line per problem row (or per group of rows with the same
   * problem), shown on the mapping step when required values are missing.
   */
  csvRowProblemLines: string[] = [];
  /** Spreadsheet row number of each parsed row; survives the blank-row filter in continue(). */
  private csvRowNumbers = new WeakMap<object, number>();
  checkbox1: any;
  csvFileName: any;
  remainingContact: any;
  customPanelClass: boolean = false;
  serchArr: any = {}; // hanldes the pagination and filters
  private itemCount = 10; // items per page
  public itemActivePagination = Array(); // handles the pagination of table
  filesize: string;
  searchListing: any = [];
  // @Input() ngTemplateOutletContext:any;
  // @Output() senddataDetails: EventEmitter<any> = new EventEmitter();
  multpleOptionFields: any[] = [];
  // multpleOptionFieldsItems: any[] = [
  //   "Items Name",
  //   "Video Url",
  //   "Website Url",
  //   "Item Code",
  //   "Unit Quantity",
  //   "Unit",
  //   "Description",
  //   "Status",
  //   "Deactivated",
  //   "Category",
  //   "Subcategory",
  //   "Images",
  //   "Item Discount",
  //   "GST",
  //   "Items Comments",
  //   "Fix Cost Per Unit",
  //   "Sales Commission",
  //   "Minimum Price",
  //   "Price A",
  //   "Price B",
  //   "Price C",
  //   "Price D",
  // ];
  previousValue: any;
  selectedMultiOptions: any;
  subscriptions: Subscription[] = [];
  files: any;
  editItemsImages = [];
  newItemsData: any;
  uploadItemsPages: any;
  private socket: any;
  progressData: { jobId: string; progress: number; name: string }[] = [];
  image: any = '';
  uploadImagesData = [];
  public imageUrl = environment.IMAGE_BACKET_URL;
  mainImageUrl: any;
  showOption: boolean = true;
  defaultsPage: any = {
    titles: {
      pageSize: 'Items per page',
    },
    pageSizes: [
      {
        value: 10,
        display: '10',
      },
      {
        value: 20,
        display: '20',
      },
      {
        value: 30,
        display: '30',
      },
      {
        value: 40,
        display: '40',
      },
      {
        value: 50,
        display: '50',
      },
    ],
  };
  pageDetail: string;
  remaining: any;
  canManagePlanAddons = false;
  constructor(
    public dialogRef: MatDialogRef<UploadCsvComponent>,
    private comSerService: ComSerService,
    private contactService: ContactService,
    private fb: FormBuilder,
    private itemsService: ItemsService,
    public snackbar: MatSnackBar,
    private translateService: TranslateService,
    public dialog: MatDialog,
    private srv: SocketService,
    private spinnerService: NgxSpinnerService,
    private permissionService: PermissionService,
    @Inject(MAT_DIALOG_DATA) public Inputdata: any,
  ) {
    const jobIdsWithProgress100 = new Set();

    this.socket = io(environment.API_URL, this.srv.workspaceSocketOptions());
    this.socket.on('jobProgress', (data) => {
      // Check if progress is 100 and the job ID is not in the set
      if (data.progress === 25 && !jobIdsWithProgress100.has(data.jobId.id)) {
        this.uploadImagesData.push(data);
        jobIdsWithProgress100.add(data.jobId.id); // Add the job ID to the set
      }
      // Find the index of the progress data with the matching job ID
      const index = this.progressData.findIndex(
        (res) => res?.jobId === data?.jobId?.id,
      );

      if (index !== -1) {
        // Update the existing progress data
        this.progressData[index].progress = data?.progress;
      } else {
        // Add a new progress data entry
        this.progressData.push({
          jobId: data?.jobId?.id,
          progress: data?.progress,
          name: data?.jobId?.data.selected_column,
        });
      }
    });
    if (this.Inputdata.hideOption != undefined) {
      this.showOption = this.Inputdata.hideOption;
    }
  }

  /** Card #600: the item sample CSV, built client-side in the app's current language. */
  downloadItemCsvSample(): void {
    downloadItemCsvTemplate(this.translateService);
  }

  async ngOnInit(): Promise<void> {
    const permission = this.permissionService.retrivePermission();
    this.canManagePlanAddons = permission?.includes('plan') && permission?.includes('billing');
    this.newItemsData = this.Inputdata?.itemsData;
    this.itemActivePagination = new Array(
      this.Inputdata?.itemsData?.totalPages,
    );
    this.pageDetail = this.Inputdata?.itemsData?.pageDetail;

    this.headingType();
    this.initializecsvformForm();
    if(this.Inputdata.checkingItems == 'newImages'){
      await this.getUploadedItems({ page: 1 });

    }
  }
  // This dialog opens its own live-update connection: close it with the dialog, otherwise every
  // opening leaves a connection (and its workspace room membership) behind.
  ngOnDestroy(): void {
    this.socket?.off('jobProgress');
    this.socket?.disconnect();
    // Card #389: a charge confirmation must not outlive the upload dialog (confirming it then would
    // do nothing): close it and drop its subscription.
    // Close first (its answer is false, so nothing is sent), then drop the subscription: unsubscribing
    // first would run finalize and forget the dialog before it is closed.
    const openDialog = this.chargeDialogRef;
    openDialog?.close(false);
    this.chargeDialogSub?.unsubscribe();
    this.chargeDialogRef = null;
  }

  ngAfterViewInit(): void {
    // const searchTerm = fromEvent<any>(this.searching.nativeElement, 'keyup').pipe(map(event => event.target.value),
    //   debounceTime(1000),
    //   distinctUntilChanged()
    // )
    // searchTerm.subscribe(res => {
    // })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.imageFilesAddedEdit(changes);
  }

  initializecsvformForm() {
    this.csvform = this.fb.group({
      tag: ['', Validators.required],
      csv: [''],
      Confirm: [false, Validators.required],
      status: ['create', Validators.required],
      item_status: ['item_create'],
      data: [''],
    });
  }

  get f() {
    return this.csvform.controls;
  }

  closebutton() {
    this.closeModel();
  }
  csvUpload() {
    this.sub = true;
    if (this.csvform.invalid) {
      this.index = 4;
      return;
    }

    const payload = this.csvform.value;

    if (this.shouldBlockContactUpdateWithoutIds(payload?.status)) {
      this.index = 4;
      return;
    }

    // Creating new contacts is not allowed when the monthly contact limit is reached.
    // Updating existing contacts (update_replace) is still allowed.
    if (this.shouldBlockContactCreateAtLimit(payload?.status)) {
      this.showContactLimitExceededSnackBar();
      return;
    }

    // Warn when the CSV has more contacts than the monthly allowance. The backend only adds up to
    // the limit, so without this the user wouldn't know the extra contacts were skipped. limit can
    // be `false` (unlimited) and may arrive as a number OR a numeric string ("6"), so coerce it
    // and only warn when it's a real number the upload exceeds.
    // Contacts only — this shared component is also used for item/lead CSV uploads, which have no
    // contact limit. Only applies to create/skip-duplicate modes that add contacts.
    // Card #389: limit 0 is NOT "0 left". Pay-as-you-go plans always answer limit 0 (no allowance
    // is counted; the server bills each import instead), the server only caps when limit is
    // truthy, and the dialog's limit banner (`remaining.limit != false`) hides on 0 too. Only 0
    // is exempt: any other number (the server never sends a negative one) keeps the old guard.
    const contactLimit = Number(this.remaining?.limit);
    const isCreatingContacts =
      payload?.status === 'create' || payload?.status === 'update';
    if (
      this.isContactCsvFlow() &&
      isCreatingContacts &&
      this.remaining &&
      this.remaining.limit !== false &&
      this.remaining.limit !== null &&
      this.remaining.limit !== '' &&
      Number.isFinite(contactLimit) &&
      contactLimit !== 0 &&
      this.records > contactLimit
    ) {
      this.SuccessSnackBar(
        this.translateService.instant('ITEMS.ContactLimitRemaining', { limit: contactLimit }),
        this.translateService.instant('COMMON.OK'),
      );
      // Stop here — do NOT call the upload API when the CSV exceeds the monthly limit.
      return;
    }

    // Card #389: an upload already on its way (or a charge dialog already open) blocks a second one,
    // so a repeated click or Enter can never send two charged imports.
    if (this.uploadInFlight || this.chargeDialogOpen) return;

    // The charge question depends on the plan; until the plan answer has arrived, a contact / lead
    // upload that adds contacts is not sent at all (rather than sent without asking).
    if (this.isContactOrLeadCsvFlow() && (payload?.status === 'create' || payload?.status === 'update') && this.remaining === undefined) {
      // Still loading -> wait a moment; the request failed -> say so (reopening the window retries it).
      const key = this.planLoadFailed ? 'ITEMS.ImportPlanLoadFailed' : 'ITEMS.ImportPlanNotLoaded';
      this.ErrorSnackBar(this.translateService.instant(key), this.translateService.instant('COMMON.OK'));
      return;
    }

    // Card #625: a pay-as-you-go workspace whose free first import is still unused is never asked
    // about a charge, whatever the file size - nothing is charged. Card #628: it gets a modal
    // instead ("your first import is free, the next file will be charged"), and the file is sent
    // only after "Import", so the user can still stop and complete the file.
    const freeFirst = isFreeFirstImport({
      addsContacts: this.isContactOrLeadCsvFlow(),
      status: payload?.status,
      remaining: this.remaining,
      freeImportAvailable: this.freeImportAvailable,
    });

    // Card #389: a big pay-as-you-go import is sent only after the user confirms the charge; the
    // server refuses an unconfirmed one of that size before charging anything.
    const confirmation = freeFirst
      ? null
      : importChargeConfirmation({
          addsContacts: this.isContactOrLeadCsvFlow(),
          status: payload?.status,
          remaining: this.remaining,
          rawRows: this.records,
          keptRows: Array.isArray(this.dataarryCsc) ? this.dataarryCsc.length : 0,
        });
    if (!freeFirst && !confirmation) {
      this.csvsubmit(payload);
      return;
    }
    this.chargeDialogOpen = true;
    try {
      this.chargeDialogRef = freeFirst
        ? this.dialog.open(ImportFreeFirstDialogComponent, {
            maxWidth: '440px',
            autoFocus: 'first-tabbable',
            restoreFocus: true,
            ariaLabelledBy: 'import-free-first-title',
            ariaDescribedBy: 'import-free-first-message',
          })
        : this.dialog.open(ImportChargeConfirmDialogComponent, {
            maxWidth: '440px',
            data: { ...confirmation, lang: this.translateService?.currentLang },
            autoFocus: 'first-tabbable',
            restoreFocus: true,
            ariaLabelledBy: 'import-charge-title',
          });
      this.chargeDialogSub = this.chargeDialogRef
        .afterClosed()
        .pipe(
          take(1),
          finalize(() => {
            this.chargeDialogOpen = false;
            this.chargeDialogRef = null;
          }),
        )
        .subscribe({
          next: (ok) => {
            // Cancel or closing the window sends nothing.
            if (ok !== true) return;
            try {
              // The free first import sends no confirmed count: nothing is charged.
              if (freeFirst || !confirmation) this.csvsubmit(payload);
              else this.csvsubmit(payload, confirmation.count);
            } catch {
              // csvsubmit already released its guard; tell the user instead of failing silently.
              this.showChargeUploadFailed();
            }
          },
          error: () => this.showChargeUploadFailed(),
        });
    } finally {
      // open() threw: the dialog never existed, so the flag must not stay set.
      if (!this.chargeDialogRef) this.chargeDialogOpen = false;
    }
  }

  /** The upload after a confirmed charge could not be started: nothing was sent, so nothing is charged. */
  private showChargeUploadFailed(): void {
    this.ErrorSnackBar(this.translateService.instant('COMMON.Something went wrong'), this.translateService.instant('COMMON.OK'));
  }

  // The upload request itself is deliberately NOT cancelled when this dialog closes: cancelling it
  // mid-flight could abort an import the user already confirmed and paid for. Its callbacks only
  // hide the spinner / close the dialog, which is harmless after destroy.

  /** True while the charge confirmation (or free first import, card #628) dialog is open. */
  private chargeDialogOpen = false;
  /** The open charge or free-first-import dialog (closed in ngOnDestroy) and its subscription. */
  private chargeDialogRef: MatDialogRef<ImportChargeConfirmDialogComponent | ImportFreeFirstDialogComponent, boolean> | null = null;
  private chargeDialogSub: Subscription | null = null;
  /** True from the upload request until its answer: blocks a second upload. */
  private uploadInFlight = false;
  /** The plan answer (validAdd) request failed: the charge question cannot be answered on this screen. */
  private planLoadFailed = false;
  /** free_import_available from the header endpoint (card #624/#625): true while unused. */
  private freeImportAvailable: unknown;

  /** Contact or lead upload: both create contacts that pay-as-you-go charges for. */
  private isContactOrLeadCsvFlow(): boolean {
    return this.Inputdata?.checkingItems !== 'value' && this.Inputdata?.checkingItems !== 'newImages';
  }

  /** True when monthly contact create allowance is exhausted (`validAdd === false`). */
  private isContactLimitExceeded(): boolean {
    return this.remaining === false;
  }

  /** Block create / skip-duplicate CSV modes when the contact limit is reached. */
  private shouldBlockContactCreateAtLimit(status: string | null | undefined): boolean {
    if (!this.isContactCsvFlow() || !this.isContactLimitExceeded()) {
      return false;
    }
    return status === 'create' || status === 'update';
  }

  private showContactLimitExceededSnackBar(): void {
    if (this.canManagePlanAddons) {
      this.SuccessSnackBarNew(
        this.translateService.instant('PROFILE.CONTACTLIMITEXCEEED'),
        this.translateService.instant('PROFILE.PURCHASE_ADDON'),
        () => {
          window.location.href = '/dash/profile/?tab=nav-plan-tab';
        },
      );
      return;
    }
    this.SuccessSnackBar(
      this.translateService.instant('PROFILE.CONTACTLIMITEXCEEED_NO_PLAN_ACCESS'),
      this.translateService.instant('COMMON.OK'),
    );
  }

  /** Contact CSV flow only (excludes items and leads). */
  private isContactCsvFlow(): boolean {
    return this.isContactOrLeadCsvFlow() && this.Inputdata?.value !== 'addLead';
  }

  /**
   * For "Edit contact details…" (update_replace), every CSV row must have an Id.
   * Shows a snackbar and returns true when the upload should be blocked.
   */
  private shouldBlockContactUpdateWithoutIds(status: string | null | undefined): boolean {
    if (!this.isContactCsvFlow() || status !== 'update_replace') {
      return false;
    }
    if (!this.hasMissingContactIds()) {
      return false;
    }

    this.SuccessSnackBar(
      this.translateService.instant('ON_BOARDING.upload_contact_ids_errors'),
      this.translateService.instant('COMMON.OK'),
    );
    return true;
  }

  /** True when the Id column is missing or any data row has an empty Id. */
  private hasMissingContactIds(): boolean {
    if (!Array.isArray(this.dataarryCsc) || this.dataarryCsc.length === 0) {
      return true;
    }

    const idColumn = this.resolveContactIdColumn();
    if (!idColumn) {
      return true;
    }

    return this.dataarryCsc.some((row) => {
      const value = row?.[idColumn];
      return value === undefined || value === null || String(value).trim() === '';
    });
  }

  /**
   * Resolve the CSV header used for contact Id.
   * Prefers the mapped field from selectItem, then a literal Id/id column on the file.
   * Matching is case-insensitive so "Id" / "id" both work.
   */
  private resolveContactIdColumn(): string | null {
    const mappedHeader = [this.selectItem?.id, this.selectItem?.Id].find(
      (value) => typeof value === 'string' && value.trim() !== '',
    ) as string | undefined;

    const sample = this.dataarryCsc?.[0];
    if (!sample || typeof sample !== 'object') {
      return mappedHeader?.trim() || null;
    }

    const keys = Object.keys(sample);
    if (mappedHeader) {
      const normalized = mappedHeader.trim().toLowerCase();
      const match = keys.find((key) => key.trim().toLowerCase() === normalized);
      if (match) {
        return match;
      }
    }

    return keys.find((key) => key.trim().toLowerCase() === 'id') || null;
  }

  closeModel() {
    this.dialogRef.close({ status: false, systempopupClose: 'contact_listing' });
  }

  emailExitlisting(data: any) {
    let filterData: any[] = data?.filter(function (value) {
      return typeof value !== 'undefined' && value;
    });
    let pay = [...new Set(filterData)];
    let payload = {
      emails: pay,
    };
    const emailexitsSubs = this.contactService.emailexits(payload).subscribe(
      (res) => {
        if (res.status) {
          this.emaildata = res.data;
          // let Jsonheading = res.data;
          // for (const [key, value] of Object.entries(Jsonheading)) {
          //   this.headingdata.push({ name: value, id: key, valueData: '' });
          // }
        }
      },
      (error) => {
        console.log(error);
      },
    );
    this.subscriptions.push(emailexitsSubs);
  }

  /**
   * The required columns the uploaded file did not supply.
   *
   * Only the starred fields matter here -- a file legitimately omits most
   * optional columns, so listing all of them would be noise nobody reads. Id is
   * added for "Modify Items", which matches rows by it: without that column the
   * import matches nothing and quietly changes nothing at all.
   */
  /**
   * Deliberately not memoised. It walks two short arrays -- the field list is
   * a few dozen entries at most -- and it is the text of a warning about data
   * the user is one click from importing. A cache keyed on the wrong thing
   * would keep showing a stale warning, or hide a real one, which costs more
   * than the walk does.
   */
  get missingRequiredColumns(): string[] {
    // Nothing to say until a file has been read.
    if (this.index < 2 || !this.allcsvlisting?.length) return [];
    // Read the mapping as it stands now, not as auto-matching left it: a
    // column picked by hand has to clear the warning (cards #299, #300). On
    // the mapping step the dropdowns are the mapping; after it, each field's
    // valueData holds the column's data and the mapping is selectItem -- the
    // field-id -> column map the upload sends.
    // Card #349: only a value that IS one of the file's column headers counts
    // as mapped. A field can hold its own label ("First Name") when the field
    // list arrived after the file was read, and a label is not a column.
    const unmapped = new Set(
      unmappedFieldIds(
        this.headingdata,
        this.index === 2 ? null : this.selectItem,
        this.allcsvlisting.map((h: any) => String(h?.id ?? '')),
      ),
    );
    const names: string[] = [];
    const seen = new Set<string>();

    (this.headingdata || []).forEach((field: any) => {
      const id = String(field?.id);
      if (field?.star && unmapped.has(id) && !seen.has(id)) {
        seen.add(id);
        names.push(this.fieldLabel(field));
      }
    });

    const mode = this.csvform?.get('item_status')?.value;
    if (mode === 'item_update_replace') {
      const idField = (this.headingdata || []).find((f: any) => String(f?.id) === 'id');
      // Guard on the field id, not the label: two fields can share a display
      // name, and 'id' is not starred today but would be double-listed if that
      // ever changed.
      if (idField && unmapped.has('id') && !seen.has('id')) {
        seen.add('id');
        names.push(this.fieldLabel(idField));
      }
    }
    return names;
  }

  /**
   * Card #536: the rows of an item file the required-field check refuses,
   * grouped by field and reason. Only fields mapped to a column are checked
   * here; an unmapped required field is reported by the column warning and the
   * existing message, unchanged.
   */
  private itemRowProblemGroups(): CsvRowProblemGroup[] {
    // The starred fields (headingType: name, category, and priceA or pricesA --
    // the header endpoint sends one spelling or the other, never both).
    const priceIds = ['priceA', 'pricesA'];
    const columnOf = (field: any): string =>
      typeof field?.valueData === 'string' ? field.valueData : '';
    const required: CsvRequiredColumn[] = (this.headingdata || [])
      .filter((f: any) => f?.star === true && columnOf(f) !== '')
      .map((f: any) => ({
        fieldId: String(f.id),
        label: this.fieldLabel(f),
        column: columnOf(f),
        isPrice: priceIds.includes(String(f.id)),
      }));
    if (!required.length) return [];
    const mappedColumn = (id: string) =>
      columnOf((this.headingdata || []).find((h: any) => String(h?.id) === id));
    const nameColumn = mappedColumn('name');
    const codeColumn = mappedColumn('code');
    const rows = (this.dataarryCsc || []).map((data: any) => ({
      // Unknown rather than a guess: the index here is AFTER the blank-row
      // filter, so it would name the wrong spreadsheet row.
      row: this.csvRowNumbers.get(data) ?? null,
      data,
    }));
    return groupCsvRowProblems(
      findCsvRowProblems(rows, required, (data) =>
        describeCsvItem(nameColumn ? data?.[nameColumn] : '', codeColumn ? data?.[codeColumn] : ''),
      ),
    );
  }

  /**
   * Translated text for the problem list. Three rows or fewer: one line each,
   * naming the item. More: one line for the group, with the row numbers.
   */
  private describeRowProblems(groups: CsvRowProblemGroup[]): string[] {
    const lines: string[] = [];
    groups.forEach((group) => {
      const invalid = group.reason === 'invalid_price';
      if (group.problems.length <= 3) {
        group.problems.forEach((p) => {
          lines.push(
            this.translateService.instant(
              invalid ? 'ON_BOARDING.csv_row_invalid_one' : 'ON_BOARDING.csv_row_missing_one',
              {
                row: p.row ?? '?',
                item: p.item || this.translateService.instant('ON_BOARDING.csv_row_unnamed'),
                field: p.label,
                column: truncateCsvValue(p.column),
                value: truncateCsvValue(p.value ?? ''),
              },
            ),
          );
        });
      } else {
        lines.push(
          this.translateService.instant(
            invalid ? 'ON_BOARDING.csv_row_invalid_many' : 'ON_BOARDING.csv_row_missing_many',
            {
              field: group.label,
              count: group.problems.length,
              rows: formatCsvRowList(group.problems.map((p) => p.row)),
            },
          ),
        );
      }
    });
    return lines;
  }

  /** A field's name as the mapping rows show it: translated, else the label the server sent. */
  private fieldLabel(field: any): string {
    const name = String(field?.name ?? field?.id ?? '');
    return this.getTranslatedText('COMMON.' + name) || name;
  }

  headingType() {
    this.dialogRef.updateSize('700px');
    if (this.Inputdata.checkingItems == 'value') {
      const headercsvfileSubs = this.contactService
        .headerItemscsvfile()
        .subscribe(
          (res) => {
            if (res.status) {
              let Jsonheading = res.data;
              for (const [key, value] of Object.entries(Jsonheading)) {
                const isStar =
                  key === 'name' || key === 'category' || key === 'priceA' || key === 'pricesA';

                this.headingdata.push({
                  name: value,
                  id: key,
                  valueData:
                    this.multpleOptionFields.indexOf(value) != -1
                      ? [value]
                      : value,
                  star: isStar,
                  multiple: this.multpleOptionFields,
                  options:
                    this.multpleOptionFields.indexOf(value) != -1
                      ? [value]
                      : value,
                });
              }
              this.rematchIfFileAlreadyRead();
            }
          },
          (error) => {
            console.log(error);
          },
        );
      this.subscriptions.push(headercsvfileSubs);
    } else {
      const headercsvfileSubs = this.contactService.headercsvfile().subscribe(
        (res) => {
          if (res.status) {
            this.remaining = res?.validAdd;
            this.freeImportAvailable = res?.free_import_available;
            if (this.remaining?.limit && this.remaining.limit > 999999) {
              this.remaining.limit = false;
            }
            // At limit: default to edit-existing so the user isn't steered into create modes.
            if (this.remaining === false) {
              this.csvform?.get('status')?.setValue('update_replace');
            }
            let Jsonheading = res.data;
            for (const [key, value] of Object.entries(Jsonheading)) {
              this.headingdata.push({
                name: value,
                id: key,
                valueData:
                  this.multpleOptionFields.indexOf(value) != -1
                    ? [value]
                    : value,
                star: key === 'first_name' ? true : false,
                multiple: this.multpleOptionFields,
                options:
                  this.multpleOptionFields.indexOf(value) != -1
                    ? [value]
                    : value,
              });
              // if(key.startsWith("additional_value_")){
              //   this.headingdata.push({ name: value, id: key, valueData:value, star: key === "first_name" ? true : false, multiple: this.multpleOptionFields });
              // }else{
              //   this.headingdata.push({ name: value, id: key, valueData:value, star: key === "first_name" ? true : false, multiple: this.multpleOptionFields  });
              // }
            }
            this.rematchIfFileAlreadyRead();
          }
        },
        (error) => {
          // Card #389: without the plan answer the charge question cannot be asked; csvUpload says so.
          this.planLoadFailed = true;
          console.log(error);
        },
      );
      this.subscriptions.push(headercsvfileSubs);
    }
  }
  datssa(ev) {
    this.searchListing = this.allcsvlisting?.filter((item) =>
      item.id?.toLowerCase().includes(ev.target.value?.toLowerCase()),
    );
  }

  // size change dialog box
  sizechange() {
    this.dialogRef.updateSize('80%');
  }

  tabledatashow() {
    let mainarra = [];
    this.dataarryCsc.forEach((value, key) => {
      if (key == 0) {
        this.headingdata.forEach((h, i) => {
          // headarray.push(h.name);
        });
        // mainarra.push(headarray);
      }

      let valarray = [];
      this.headingdata.forEach((head, i) => {
        if (head.valueData != '') {
          for (const [key, values] of Object.entries(value)) {
            if (key == head.valueData) {
              valarray.push(values);
            }
          }
        } else {
          valarray.push(null);
        }
      });
      mainarra.push(valarray);
    });
    this.showData = mainarra;
  }
  contiineItems() {
    if (this.itemsCsvFile.length > 0) {
      if (this.csvFile.value?.length > 0 && this.editItemsImages?.length > 0) {
        for (let i of this.csvFile.value) {
          for (let j of this.itemsCsvFile) {
            if (i == j.id) {
              for (let k of this.editItemsImages) {
                if (j.item_images?.length > 0) {
                  j.item_images.push({ image: k.image });
                } else j.image = [{ image: k.image }];
              }
              break;
            }
          }
        }
      }
    }
    if (this.itemsCsvFile.length) {
      this.contactService.uploadItemsCsv(this.itemsCsvFile).subscribe(
        (res) => {
          if (res.status) {
            this.dialogRef.close(true);
          }
        },
        (error) => {
          console.log(error);
        },
      );
    }
  }

  continue() {
    this.spinnerService.show();

    setTimeout(() => {
      this.index = this.index + 1;
      if (this.index === 3) {
        if (this.dataarryCsc?.length) {
          // Drop rows that have no real column header or no non-empty value
          // (single pass instead of two filters over the whole dataset).
          this.dataarryCsc = this.dataarryCsc.filter((element) => {
            const hasValidKey = Object.keys(element).some((key) => {
              const trimmedKey = key.trim();
              return trimmedKey !== '' && trimmedKey !== '\r';
            });
            if (!hasValidKey) return false;
            return Object.values(element).some(
              (value) => typeof value === 'string' && value.trim() !== '',
            );
          });
        }
        // Card #536: list every row a required value is missing from (or whose
        // price is not a number), instead of one sentence about the first one.
        // Items only. Both this list and the item branch of the `first_name`
        // check below use the rules in csv-row-problems.ts, in every
        // item_status mode; for items that check now only fires for an
        // UNMAPPED required field. Contacts are unchanged.
        this.csvRowProblemLines = [];
        if (this.Inputdata?.checkingItems == 'value') {
          const rowProblems = this.itemRowProblemGroups();
          if (rowProblems.length) {
            this.csvRowProblemLines = this.describeRowProblems(rowProblems);
            this.index = 2;
            this.ErrorSnackBar(
              this.translateService.instant('ON_BOARDING.csv_row_problems_snackbar'),
              this.translateService.instant('COMMON.OK'),
            );
            this.spinnerService.hide();
            return;
          }
        }
        const first_name = this.headingdata.find((x) => {
          if (x.id === 'first_name') {
            if (x.valueData != '') {
              let valueData: string = '';
              return this.dataarryCsc.find(function (element) {
                x?.valueData?.includes('string') == false
                  ? (valueData = x.valueData.toString())
                  : (valueData = x.valueData);
                return (
                  element[x.valueData] === '' ||
                  element[x.valueData] === undefined
                );
              });
            } else {
              return 'abc';
            }
          }
          if (this.Inputdata.checkingItems == 'value') {
            if (x.id === 'name' || x.id === 'priceA' || x.id === 'pricesA' || x.id === 'category') {
              if (x.valueData != '') {
                let valueData: string = '';
                return this.dataarryCsc.find(function (element) {
                  x?.valueData?.includes('string') == false
                    ? (valueData = x.valueData.toString())
                    : (valueData = x.valueData);
                  // Same price pattern and "missing" rule as the card #536 row
                  // list above (csv-row-problems.ts): any number of decimals
                  // (112.211, 87.525), optional thousands separators.
                  if (x.id === 'priceA' || x.id === 'pricesA') {
                    if (element[x.valueData] && !CSV_PRICE_PATTERN.test(element[x.valueData].trim())) {
                      return 'Price is not valid';
                    }
                  }
                  return isMissingCsvValue(element[x.valueData]);
                });
              } else {
                return 'abc';
              }
            }
          }
        });

        if (first_name?.id == 'priceA' || first_name?.id == 'pricesA') {
          this.index = 2;
          const message = this.translateService.instant(
            'ON_BOARDING.invalid_price',
          );

          // Card #533: these are errors, so error styling (was SuccessSnackBar)
          this.ErrorSnackBar(
            message,
            this.translateService.instant('COMMON.Cancel'),
          );
          this.spinnerService.hide();
          return;
        }

        if (first_name) {
          this.index = 2;
          const message =
            this.Inputdata?.checkingItems === 'value'
              ? this.translateService.instant(
                  'ON_BOARDING.please_select_required_fields',
                )
              : this.translateService.instant(
                  'ON_BOARDING.please_select_first_name',
                );

          this.ErrorSnackBar(
            message,
            this.translateService.instant('COMMON.Cancel'),
          );
          this.spinnerService.hide();
          return;
        }
        this.dialogRef.updateSize('930px');
        // tabledatashow() built `showData`, which is never rendered — skipping it
        // avoids an O(rows × columns) pass that froze the UI on large uploads.
        let data = this.headingdata.find((x) => x.valueData != '');
        if (!data) {
          this.index = 2;
          this.ErrorSnackBar(
            this.translateService.instant('COMMON.Select_option'),
            this.translateService.instant('COMMON.Cancel'),
          );
        }

        this.headingdata.forEach((ele) => {
          let data: any[] = [];
          let valueData: string = ele.valueData?.toString() || '';

          // Check if the value starts with 'email'
          ele['emailcheked'] = valueData.toLowerCase().startsWith('email');

          // Store selected item
          if (valueData !== '') {
            this.selectItem[ele.id] = valueData;
          }

          // Process data mapping
          data = this.dataarryCsc.map((element) => {
            let newValue = '';

            // If valueData is an array, extract values from element
            if (Array.isArray(ele.valueData) && ele.valueData.length > 0) {
              newValue = ele.valueData
                .map((key) => element[key] || '')
                .filter(Boolean) // Remove empty values
                .join(', ');
            }
            // If valueData matches a key in element, get corresponding value
            else if (valueData in element) {
              newValue = element[valueData];
            }

            return newValue;
          });

          // Assign processed values back
          ele.valueData = data.length
            ? data
            : new Array(this.headingdata[0]?.valueData?.length).fill(null);
        });

        this.headingdata.forEach((element) => {
          if (element.valueData.length === 0) {
            for (let j = 0; j < this.headingdata[0]?.valueData?.length; j++) {
              element.valueData.push(null);
            }
          }
        });
      } else if (this.index === 4) {
        this.headingdata.forEach((ele) => {
          // if (ele.emailcheked) {
          //   this.emailcheckeking = [...this.emailcheckeking, ...ele.valueData];
          // }
          // this.emailInsert.forEach(element => {
          //   if (ele.valueData === element) {
          //     this.emailcheckeking.push(element);
          //   }
          // });
        });
        // this.emailExitlisting(this.emailcheckeking);
        this.dialogRef.updateSize('650px');
      } else if (this.index === 5) {
        const contactStatus = this.csvform.get('status')?.value;
        if (this.shouldBlockContactUpdateWithoutIds(contactStatus)) {
          this.spinnerService.hide();
          this.index = 4;
          return;
        }

        const update = this.csvform.get('item_status').value;

        //Only run validation for 2nd and 3rd options
        if (update === 'item_update_replace') {
          let hasError = false;

          this.dataarryCsc.forEach((ele, index) => {
            if (ele?.Id === undefined || ele?.Id === null || ele?.Id === '') {
              console.error(
                `Error: Item ${index + 1} is missing the 'id' or it has no value.`,
              );
              hasError = true;
            }
          });

          if (hasError) {
            this.spinnerService.hide();
            this.SuccessSnackBarNew(
              this.translateService.instant('ON_BOARDING.upload_ids_errors'),
              this.translateService.instant('COMMON.click_here'),
              () => this.downloadCSV(),
            );
            this.index = 4;
            return;
          }
        }
        this.dialogRef.updateSize('650px');
      }
      this.spinnerService.hide();
      // this.headingdata = this.sortHeadingData(this.headingdata);
    }, 100);
  }

  csvsubmit(payload: any, confirmedNewContacts?: number) {
    if (this.uploadInFlight) return; // a second click while the upload is on its way sends nothing
    this.uploadInFlight = true;
    try {
      this.sendUpload(payload, confirmedNewContacts);
    } catch (err) {
      // Something failed before the request existed (finalize will never run): release the guard.
      this.uploadInFlight = false;
      this.spinnerService?.hide();
      throw err;
    }
  }

  private sendUpload(payload: any, confirmedNewContacts?: number) {
    this.spinnerService.show();
    const merchant_id = localStorage.getItem('merchant_id');
    const userData =
      localStorage.getItem('loginUserValue') &&
      JSON.parse(localStorage.getItem('loginUserValue'));
    const isItemUpload = this.Inputdata?.checkingItems === 'value';
    const moduleName =
      this.Inputdata?.value === 'addLead'
        ? 'lead'
        : isItemUpload
          ? 'item_module'
          : 'contact';

    const formData = new FormData();
    formData.append(`merchant_id`, merchant_id);
    formData.append(`tag`, payload.tag);
    formData.append(`csv`, this.fileUploading);
    formData.append(`Confirm`, payload.Confirm);
    formData.append(`module_name`, moduleName);
    // Contacts/leads use `status`; item uploads use `item_status` only.
    if (isItemUpload) {
      formData.append(`item_status`, payload.item_status);
    } else {
      formData.append(`status`, payload.status);
    }
    formData.append(`data`, JSON.stringify(this.emaildata));
    formData.append(`selectedItems`, JSON.stringify(this.selectItem));
    formData.append(`lang`, userData?.languages?.locale);
    // Card #389: how many new contacts the user agreed to pay for (only after the charge dialog).
    if (Number.isInteger(confirmedNewContacts) && (confirmedNewContacts as number) > 0) {
      formData.append(`confirmed_new_contacts`, String(confirmedNewContacts));
    }
    this.contactService.uploadCsv(formData).pipe(finalize(() => { this.uploadInFlight = false; })).subscribe(
      (res) => {
        this.spinnerService.hide();
        if (res.status) {
          this.dialogRef.close(true);
          // this.emaildata = res.data;
        }
      },
      (error) => {
        this.spinnerService.hide();
        // Card #389: the server refused the confirmed charge count; say so in the user's language.
        if (isUploadChargeRefusal(error)) {
          this.ErrorSnackBar(this.translateService.instant('ITEMS.ImportChargeConfirmRefused'), this.translateService.instant('COMMON.OK'));
        }
      },
    );
  }
  getTranslatedText(key: string): string {
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : '';
  }

  handleFileInput(event) {
    this.spinnerService.show();
    setTimeout(() => {
      let reader = new FileReader();
      const fileObj = event.target.files?.[0];
      if (!fileObj) {
        this.spinnerService.hide();
        return;
      }
      const maxSizeBytes = 15 * 1024 * 1024; // 15 MB
      if (fileObj.size > maxSizeBytes) {
        this.fileUploading = '';
        this.filesize = '';
        if (event.target) {
          event.target.value = '';
        }
        this.spinnerService.hide();
        const errorMsg =
          this.translateService.instant('ON_BOARDING.csv_file_size_limit_exceeded') ||
          'The CSV file size exceeds the 15 MB limit. Please select a smaller file.';
        this.ErrorSnackBar(errorMsg, this.translateService.instant('COMMON.OK'));
        return;
      }
      let _size = fileObj.size;
      let fSExt = new Array('Bytes', 'KB', 'MB', 'GB'),
        i = 0;
      while (_size > 900) {
        _size /= 1024;
        i++;
      }
      let exactSize = Math.round(_size * 100) / 100 + ' ' + fSExt[i];
      this.filesize = exactSize;
      if (event.target.files && event.target.files.length) {
        const files = event.target.files[0];
        let condition: any = event.target.files[0].name.split('.');
        this.f.tag.setValue(condition.slice(0)[0]);
        const value = condition.slice(-1)[0];
        if (value === 'csv') {
          this.fileUploading = files;
          const [file] = event.target.files;
          const input = event.target as HTMLInputElement;
          reader.readAsDataURL(file);
          reader.onload = () => {
            const filebase64 = reader.result as string;
            let accepted = false;
            try {
              accepted = this.readcsv(filebase64);
            } catch (e) {
              // Card #586: a file that cannot be read is refused like an empty one.
              console.error('CSV file could not be read.', e);
              this.refuseEmptyCsv();
            }
            // Card #586: a refused file is cleared, so picking the same file again still fires.
            if (!accepted) {
              input.value = '';
            }
          };
        } else {
          this.fileUploading = '';
          this.spinnerService.hide();
          alert('please csv file Upload');
        }
      }
    }, 100);
  }

  /** Card #586: an empty or unreadable file left the spinner up with no message. */
  private refuseEmptyCsv(): void {
    this.fileUploading = '';
    this.filesize = '';
    this.spinnerService.hide();
    this.ErrorSnackBar(this.translateService.instant('ON_BOARDING.csv_file_empty'), this.translateService.instant('COMMON.OK'));
  }

  /** Reads the picked file into the mapping step; false when the file was refused. */
  readcsv(base64csv: string): boolean {
    const base64 = base64csv.split(',')[1];
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    // Card #349: UTF-8 first, Latin-1 only when the bytes are not UTF-8 (a
    // Google Sheets export has no byte-order mark and showed "PrÃ©nom").
    const cleanedCSV = decodeCsvBytes(bytes);
  
    // Card #530: each row keeps its own spreadsheet row number, because parseCSV drops
    // blank and single-cell lines and a position in the filtered list is not a row.
    const parsedRows = this.parseCSVWithRows(cleanedCSV);
    const parsedCSV = parsedRows.map((r) => r.cells);
    if (parsedCSV.length < 2) {
      console.error('CSV file appears empty or malformed.');
      this.refuseEmptyCsv();
      return false;
    }
  
    const keyValue = parsedCSV[0];
    const recordArray = parsedRows.slice(1);
    this.records = recordArray.length;
  
    let dataArray: any[] = [];
    this.csvRowNumbers = new WeakMap<object, number>();
    this.csvRowProblemLines = [];
    recordArray.forEach(({ cells, row: sheetRow }) => {
      let allcsvData: any = {};
      cells.forEach((value, i) => {
        const key = keyValue[i] || `Column_${i}`;
        allcsvData[key] = value.replace(/\r/g, '');
      });
      this.csvRowNumbers.set(allcsvData, sheetRow);
      dataArray.push(allcsvData);
    });

    this.dataarryCsc = dataArray;
  
    this.emailInsert = dataArray.flatMap((row) =>
      Object.entries(row)
        .filter(([key]) => key.toLowerCase().includes('email'))
        .map(([, value]) => value),
    );
  
    this.allcsvlisting = Array.from(new Set(keyValue)).map((key) => ({
      name: key,
      id: key,
      disable: false,
    }));

    this.matchFileColumns();

    this.index = 2;
    this.spinnerService.hide();
    return true;
  }

  /**
   * Card #349: the field list is fetched when the dialog opens and took 3-35 s
   * on dev. A file picked before it arrived was matched against an empty list,
   * and was never matched again -- the fields kept their labels. When the list
   * lands while the user is on the mapping step, match the file's columns now.
   * Not after the mapping step: by then each field's valueData holds column
   * DATA, and the user has already chosen.
   */
  private rematchIfFileAlreadyRead(): void {
    if (this.index === 2 && this.allcsvlisting?.length) {
      this.matchFileColumns();
    }
  }

  /** Point every field at one of the file's columns, and mark the taken columns in the dropdowns. */
  private matchFileColumns(): void {
    // The auto-mapping used to require the CSV header to equal our DISPLAY
    // LABEL character for character, so a file exported from Osmos itself
    // failed on its own columns: "Name" never matched the label "Item Name",
    // "PriceA" never matched "Price A", "ID" never matched "Id". Those three
    // are exactly the ones "Modify Items" depends on, and a user who did not
    // notice imported a catalogue with no names or prices -- or, in Modify
    // Items, silently changed nothing at all.
    // Item uploads also match headers written in another language (card #589),
    // and so does the contacts upload (card #614).
    const isItemUpload = this.Inputdata?.checkingItems == 'value';
    resolveHeaderMapping(
      this.headingdata,
      (this.allcsvlisting || []).map((h: any) => h.id),
      // Card #614: isContactCsvFlow() excludes the 'newImages' flow and lead
      // uploads (value === 'addLead'), which !isItemUpload would wrongly
      // have counted as contacts.
      { items: isItemUpload, contacts: this.isContactCsvFlow() },
    );
  
    // `x.valueData || (x.valueData[0] !== '' ...)` reads index 0 of a value it
    // has just established is falsy, so a null or undefined here throws. It
    // survived because valueData always used to hold a label; now that
    // unmatched fields are cleared, empty values flow through this line.
    let newarray = this.headingdata
      .map((x) => {
        if (x.valueData == null) return '';
        return x.valueData || (x.valueData[0] !== '' ? x.valueData : '');
      })
      .filter((val) => val !== '');
    const newData = [].concat(...newarray);
  
    this.allcsvlisting.forEach((ele) => {
      let id = ele.id.trim().replace(/\d$/, '');
      ele.disable = newData.includes(id.trim());
    });
  
    this.headingdata.forEach((x) => {
      x['searchTxt'] = undefined;
    });
  }

  // Old readcsv in future use

  // readcsv(csv: string) {
  //   const readcsvSubs = this.comSerService.readcsv(csv).subscribe((res) => {
  //     console.log(res, 'Raw CSV Response');

  //     if (res) {
  //       let arr: any[] = [];
  //       let recordArray: any[] = [];
  //       const cleanedCSV = res.replace(/\uFFFD/g, '†'); // Replace unknown chars (�) with actual symbol

  //       // Convert CSV to lines, preserving quoted multi-line values
  //       const parsedCSV = this.parseCSV(cleanedCSV);
  //       console.log(parsedCSV, 'Parsed CSV');

  //       if (parsedCSV.length < 2) {
  //         console.error('CSV file appears empty or malformed.');
  //         return;
  //       }

  //       // Extract header row
  //       const keyValue = parsedCSV[0];

  //       // Extract valid data rows
  //       recordArray = parsedCSV.slice(1);
  //       this.records = recordArray.length;
  //       console.log(this.records, 'Total Records');

  //       let dataArray: any[] = [];

  //       // Map data into key-value objects
  //       recordArray.forEach((row) => {
  //         let allcsvData: any = {};
  //         row.forEach((value, i) => {
  //           const key = keyValue[i] || `Column_${i}`;
  //           allcsvData[key] = value.replace(/\r/g, ''); // Remove carriage return
  //         });
  //         dataArray.push(allcsvData);
  //       });

  //       this.dataarryCsc = dataArray;
  //       console.log(this.dataarryCsc, 'Final Data Array');

  //       // Extract email fields dynamically
  //       this.emailInsert = dataArray.flatMap((row) =>
  //         Object.entries(row)
  //           .filter(([key]) => key.toLowerCase().includes('email'))
  //           .map(([, value]) => value),
  //       );

  //       // Generate unique column list
  //       this.allcsvlisting = Array.from(new Set(keyValue)).map((key) => ({
  //         name: key,
  //         id: key,
  //         disable: false,
  //       }));

  //       // Update column selection status based on `headingdata`
  //       let newarray = this.headingdata
  //         .map((x) => x.valueData || (x.valueData[0] !== '' ? x.valueData : ''))
  //         .filter((val) => val !== '');
  //       const newData = [].concat(...newarray);

  //       this.allcsvlisting.forEach((ele) => {
  //         let id = ele.id.trim().replace(/\d$/, '');
  //         ele.disable = newData.includes(id.trim());
  //       });

  //       // Clear search fields
  //       this.headingdata.forEach((x) => {
  //         x['searchTxt'] = undefined;
  //       });

  //       this.index = 2;
  //       this.spinnerService.hide();
  //     }
  //   });

  //   this.subscriptions.push(readcsvSubs);
  // }
  

  /**
   * Parses a CSV string while handling multi-line quoted values correctly.
   */
  parseCSV(csv: string): string[][] {
    return this.parseCSVWithRows(csv).map((r) => r.cells);
  }

  /**
   * Same rows as parseCSV, each with its spreadsheet row number (card #530): the
   * first line is row 1, every line end outside quotes starts the next row (CRLF
   * counts once), and a quoted value spanning lines stays in its one row.
   */
  parseCSVWithRows(csv: string): { cells: string[]; row: number }[] {
    const rows: { cells: string[]; row: number }[] = [];
    let currentRow: string[] = [];
    let currentField = '';
    let insideQuotes = false;
    let line = 1;

    for (let i = 0; i < csv.length; i++) {
      const char = csv[i];
      const nextChar = csv[i + 1];

      if (char === '"' && nextChar === '"') {
        // Handle escaped quotes ("")
        currentField += '"';
        i++; // Skip next char
      } else if (char === '"') {
        insideQuotes = !insideQuotes; // Toggle quote state
      } else if (char === ',' && !insideQuotes) {
        // Split on commas only if outside quotes
        currentRow.push(currentField.trim());
        currentField = '';
      } else if ((char === '\n' || char === '\r') && !insideQuotes) {
        // End of line, push current row
        if (currentField || currentRow.length) {
          currentRow.push(currentField.trim());
          rows.push({ cells: currentRow, row: line });
        }
        currentRow = [];
        currentField = '';
        if (char === '\r' && nextChar === '\n') i++; // CRLF is one line end
        line++;
      } else {
        currentField += char; // Append character to field
      }
    }

    // Push last row if not empty
    if (currentField || currentRow.length) {
      currentRow.push(currentField.trim());
      rows.push({ cells: currentRow, row: line });
    }

    return rows.filter((r) => r.cells.length > 1); // Remove empty rows
  }

  parseHeaderLine(headerLine: string): string[] {
    const keys = [];
    let inQuotes = false;
    let currentKey = '';

    for (let i = 0; i < headerLine.length; i++) {
      const char = headerLine[i];

      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        keys.push(currentKey.trim());
        currentKey = '';
      } else {
        currentKey += char;
      }
    }

    if (currentKey) {
      keys.push(currentKey.trim());
    }

    return keys;
  }

  headingDataMap(x) {
    return x.valueData || x.valueData[0] != '' ? x.valueData : '';
  }
  // listingdata(item:any){
  //   return
  // }

  SuccessSnackBar(msg, tag) {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'top';
    config.horizontalPosition = 'right';
    config.duration = 10000;
    config.panelClass = this.customPanelClass
      ? 'notif-success2'
      : 'notif-success'; // Default success style class
    this.snackbar.open(msg, tag, config);
  }

  ErrorSnackBar(msg, tag) {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'top';
    config.horizontalPosition = 'right';
    config.duration = 10000;
    config.panelClass = 'notif-error';
    this.snackbar.open(msg, tag, config);
  }

  SuccessSnackBarNew(message: string, action: string, callback?: () => void) {
    let config: MatSnackBarConfig = {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 10000,
      panelClass: this.customPanelClass ? 'notif-success2' : 'notif-success',
    };

    const snackBarRef = this.snackbar.open(message, action, config);

    // If a callback function is provided, execute it when the user clicks the action button
    if (callback) {
      snackBarRef.onAction().subscribe(() => {
        callback();
      });
    }
  }

  noOptionSelection(event, value) {
    this.csvRowProblemLines = [];
    let index: number = 0;
    index = this.allcsvlisting.findIndex((object) => {
      return object.id === value;
    }); // 👉️ 1

    if (index !== -1) {
      this.allcsvlisting[index].disable = false;
    }
  }
  isOptionDisabled(optionValue: string): boolean {
    return this.headingdata.some((item) => {
      if (Array.isArray(item.valueData)) {
        return item.valueData.includes(optionValue);
      }
      return item.valueData === optionValue;
    });
  }
  isMultipleField(name: string): boolean {
    return this.multpleOptionFields.some(
      (f) => f.toLowerCase() === name?.toLowerCase(),
    );
  }

  onClickChangeOptions(event, value) {
    this.selectedMultiOptions = []; // Clear previous selection to avoid leakage
    //value = value.trim() .replace(/\d$/, '');
    if (Array.isArray(value) && value?.length > 0) {
      if (value != undefined) {
        //value = value.trim() .replace(/\d$/, '');
        this.allcsvlisting.forEach((ele) => {
          //let id = ele.id.trim() .replace(/\d$/, '');
          // if(Array.isArray(value) && value?.length > 0){
          ele.id?.trim()?.indexOf(value) != -1
            ? (ele.disable = false)
            : (ele.disable = true);
          // }// }else{
          //   value?.includes(id?.trim()) ? ele.disable = false : ele.disable = true;
          // }
        });
      }
    } else {
      this.allcsvlisting.forEach((ele) => {
        let id = ele.id.trim().replace(/\d$/, '');
        let index: number = 0;
        index = this.allcsvlisting.findIndex((object) => {
          return object.id.trim() === ele.id.trim();
        });

        if (index !== -1) {
          if (
            this.Inputdata.checkingItems == 'value'
              ? this.multpleOptionFields.indexOf(id.trim()) != -1
              : this.multpleOptionFields.indexOf(id.trim()) != -1
          ) {
            this.allcsvlisting[index].disable = true;
            //console.log(index +"---"+this.allcsvlisting[index].id +"---"+this.allcsvlisting[index].disable);
          }
        }

        // this.multpleOptionFields.indexOf(id.trim()) != -1? ele.disable = true : ele.disable = false;
      });

      //value = value.trim() .replace(/\d$/, '');
      let index: number = 0;
      index = this.allcsvlisting.findIndex((object) => {
        return object.id === value;
      });
      if (index !== -1) {
        this.allcsvlisting[index].disable = false;
      }
    }

    // if(value != undefined){
    //   value = value.trim() .replace(/\d$/, '');
    //   this.allcsvlisting.forEach(ele => {
    //     let id = ele.id.trim() .replace(/\d$/, '');
    //     if(Array.isArray(value) && value?.length > 0){
    //       value?.includes(id?.trim()) ? ele.disable = false : ele.disable = true;
    //     }else{
    //       value?.includes(id?.trim()) ? ele.disable = false : ele.disable = true;
    //     }
    //   });
    // }
  }
  optionSelection(event, value, arrayValue, optionName, label) {
    // if(value != undefined){
    //   value = value.trim() .replace(/\d$/, '');
    //   this.allcsvlisting.forEach(ele => {
    //     let id = ele.id.trim() .replace(/\d$/, '');
    //     if(Array.isArray(value) && value?.length > 0){
    //       value?.includes(id?.trim()) ? ele.disable = true : ele.disable = false;
    //     }else{
    //       value?.includes(id?.trim()) ? ele.disable = true : ele.disable = false;
    //     }
    //   });
    // }
    let index: number = 0;
    index = this.allcsvlisting.findIndex((object) => {
      return object.id === value;
    }); // 👉️ 1

    if (index !== -1) {
      if (
        Array.isArray(this.selectedMultiOptions) &&
        this.selectedMultiOptions?.length > 0
      ) {
        this.allcsvlisting.forEach((ele) => {
          let id = ele.id.trim().replace(/\d$/, '');
          ele.id.indexOf(label) != -1
            ? (ele.disable = false)
            : (ele.disable = true);
        });

        //this.allcsvlisting[index].disable = this.selectedMultiOptions.indexOf(optionName) != -1
        //this.allcsvlisting[index].disable = false
      } else {
        this.allcsvlisting[index].disable = true;
      }
    }
    this.previousValue = value;

    // value = value.trim() .replace(/\d$/, '');
    // this.allcsvlisting.forEach(ele => {
    //   let id = ele.id.trim() .replace(/\d$/, '');
    //   console.log(value + "====" + id);
    //   value?.includes(id.trim()) ? ele.disable = true : ele.disable = false;
    // });
  }
  onOptionsSelected(event: MatSelectChange, value) {
    this.selectedMultiOptions = event.value;
    // Card #536: the row list described the OLD mapping; Continue re-checks.
    this.csvRowProblemLines = [];

    //const matSelect: MatSelect = event.source;
    //matSelect.writeValue(null);
    //console.log(this.headingdata);
    // let newarray = [];
    // newarray = this.headingdata.map((x) => x.valueData != "" ? x.valueData : "").filter(val => val != "");
    // if(value != undefined){
    //   value = value.trim() .replace(/\d$/, '');
    //   this.allcsvlisting.forEach(ele => {
    //     let id = ele.id.trim() .replace(/\d$/, '');
    //     if(Array.isArray(value) && value?.length > 0){
    //       value?.includes(id?.trim()) ? ele.disable = true : ele.disable = false;
    //     }else{
    //       value?.includes(id?.trim()) ? ele.disable = true : ele.disable = false;
    //     }
    //   });
    // }
  }

  sortHeadingData(headingData) {
    if (headingData?.length > 0) {
      const sortedArr = headingData.sort((a, b) =>
        a.valueData < b.valueData ? 1 : -1,
      );
      return sortedArr;
    } else {
      return headingData;
    }
  }

  //#region UPload CSV
  onFileSelected(event: any): void {
    this.csvFileName = event.target.value;
    let pathParts = event.target.value.split('\\');

    // Get the last part, which is the filename
    this.csvFileName = pathParts[pathParts.length - 1];

    const file: File = event.target.files[0];
    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          this.createData(result.data);
        },
      });
    }
  }

  createData(csvData) {
    const propertyNames = csvData[0];
    const arrayOfObjects = [];

    for (let i = 1; i < csvData.length; i++) {
      const rowData = csvData[i];
      const obj = {};
      for (let j = 0; j < propertyNames.length; j++) {
        const propertyName = propertyNames[j];
        const value = rowData[j];
        obj[propertyName] = value;
      }
      arrayOfObjects.push(obj);
    }

    let uniqueArray = [];
    let duplicatesArray = [];

    for (let mainEle of arrayOfObjects) {
      let isDuplicate = false;
      for (let elem of uniqueArray) {
        if (mainEle.Id === elem.Id) {
          isDuplicate = true;
          duplicatesArray.push(mainEle);
          break;
        }
      }
      if (!isDuplicate) {
        uniqueArray.push(mainEle);
      }
    }

    let finalArray = [];

    for (let unique of uniqueArray) {
      let imagesArray = [];

      if (unique.Images) {
        const imageFilenames = unique.Images.split(',').map((filename) =>
          filename.trim(),
        );
        imageFilenames.forEach((filename) => {
          imagesArray.push({ image: filename });
        });
      }
      let itemsComments = [];
      if (unique['Items Comments']) {
        const commentTexts = unique['Items Comments']
          .split(',')
          .map((comment) => comment.trim());
        commentTexts.forEach((comment) => {
          itemsComments.push({ title: comment });
        });
      }

      for (let duplicate of duplicatesArray) {
        if (duplicate.Id === unique.Id) {
          imagesArray.push({ image: duplicate.Images });
        }
      }

      let taxData = [];

      try {
        const taxValue = unique['Tax Values'];

        // Check if taxValue is defined and is a non-empty string
        if (typeof taxValue === 'string' && taxValue.trim() !== '') {
          const parsedTaxValue = JSON.parse(taxValue);
          taxData.push({
            taxe_value: parsedTaxValue.taxe_value,
            customValueId: parsedTaxValue.customValueId,
          });
        } else {
          console.error('Tax data is not a valid JSON string:', taxValue);
        }
      } catch (error) {
        console.error('Error parsing tax data:', error);
      }
      finalArray.push({
        id: unique.Id,
        name: unique['Items Name'],
        item_prices: [
          {
            discount: unique['Item Discount'],
            price: JSON.stringify({
              pricesA: unique['Price A'],
              pricesB: unique['Price B'],
              pricesC: unique['Price C'],
              pricesD: unique['Price D'],
            }),
            fix_cost_per_unit: unique['Fix Cost Per Unit'],
            sales_commission: unique['Sales Commission'],
            min_price: unique['Minimum Price'],
          },
        ],
        item_images: imagesArray,
        isDeactivated:
          unique.Deactivated == 'null' ? false : unique.Deactivated,
        code: unique['Item Code'],
        comments: itemsComments,
        description: unique.Description,
        video_url: unique['Video Url'],
        website_url: unique['Website Url'],
        unit_quantity: unique['Unit Quantity'],
        unit: unique.Unit,
        item_prices_taxs: taxData,
        subcategoryName: unique.Subcategory,
        categoryName: unique.Category,
      });
    }
    this.itemsCsvFile = finalArray;
  }

  openItemCsv() {
    this.showCsvDropdown = true;
  }

  async imageFilesAddedEdit(event: any) {
    const formData = new FormData();
    for (var i = 0; i < event.target.files.length; ++i) {
      this.files = event.target.files[i];
      if (this.files !== null || this.files !== undefined) {
        formData.append('files', this.files);
      }
      const uploadItemPhotoSubs = this.itemsService
        .uploadItemPhoto(formData)
        .subscribe((res) => {
          if (res.message === 'success' || res.status === 1) {
            this.editItemsImages.push({ image: res.data.image });
            this.image = { image: res.data.image };
          }
        });
      this.subscriptions.push(uploadItemPhotoSubs);
    }
  }

  matchedItem: any = {};
  async uploadItemImages(item, index) {
    if (!this.uploadImagesData.length) {
      // If the uploadImagesData array is empty, open the UploadImagesPreviewModelComponent
      const dialogRef = this.dialog.open(UploadImagesPreviewModelComponent, {
        maxHeight: '500px',
        height: '500px',
        width: '600px',
        data: item,
      });

      dialogRef.afterClosed().subscribe(async (dialogResult) => {
        if (dialogResult) {
          // Handle the result if needed
          this.newItemsData.data[index].disabled = true;
        }
      });
    } else {
      let foundMatch = false;
      for (const responseItem of this.uploadImagesData) {
        if (responseItem.jobId.data.file_link == item.id) {
          this.customPanelClass = true;
          this.SuccessSnackBar(this.translateService.instant('Snackbar.Images already uploaded for this item'), this.translateService.instant('COMMON.OK'));
          foundMatch = true;
          break; // Exit the loop since we found a match
        }
      }

      if (!foundMatch) {
        const dialogRef = this.dialog.open(UploadImagesPreviewModelComponent, {
          maxHeight: '500px',
          height: '500px',
          width: '600px',
          data: item,
        });

        dialogRef.afterClosed().subscribe(async (dialogResult) => {
          if (dialogResult) {
            // Handle the result if needed
            this.newItemsData.data[index].disabled = true;
          }
        });
      }
    }
  }

  async removeItem(i, type) {
    const dialogData = new ModalModel(
      this.translateService.instant('PROFILE.CONFIRMDELETE'),
    );
    const dialogRef = this.dialog.open(ModalComponent, {
      maxWidth: '400px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        if (type == 'imgRemove') {
          const imageIndex = this.editItemsImages.indexOf(i);

          this.editItemsImages.splice(imageIndex, 1);
          this.image = this.editItemsImages[0];
        }
      }
    });
  }

  changeImage(index, id) {
    this.image = this.editItemsImages[index];
    this.mainImageUrl = id;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  async getUploadedItems(payload) {
    this.serchArr = {
      pagination: true,
      limit: payload.pageLimit ? payload.pageLimit : this.itemCount,
      page: payload.page ? payload.page : 1,
      // filter: { "categoryId": this.catId }
    };
    if (this.Inputdata?.value == 'allItems') {
      const itemSearchSubs = this.itemsService
        .itemSearch(this.serchArr)
        .subscribe((res) => {
          if (res?.data?.length) {
            this.newItemsData = res;
            this.pageDetail = res?.pageDetail;
            this.itemActivePagination = new Array(res.totalPages);
          }
        });
    } else {
      const itemSearchSubs = this.itemsService
        .itemSearchUploaded(this.serchArr)
        .subscribe((res) => {
          if (res?.data?.length) {
            this.newItemsData = res;
            this.pageDetail = res?.pageDetail;
            this.itemActivePagination = new Array(res.totalPages);
          }
        });
    }
  }
  paginationPageSize(pageSize) {
    (this.itemCount = pageSize), this.getUploadedItems({ pageLimit: pageSize });
  }
  async paginationPage(i) {
    this.getUploadedItems({ page: i });
  }

  downloadCSV() {
    const getDownloadcvsCatalogSubs = this.itemsService
      .getDownloadcvsCatalog()
      .subscribe((response: any) => {
        // Split the CSV data into rows
        const rows = response.split('\n');

        // Create a Set to keep track of unique rows
        const uniqueRows = new Set();

        // Initialize a new array to store the filtered rows
        const filteredRows = [];

        // Iterate through each row
        for (let i = 0; i < rows.length; i++) {
          // Check if the row is unique (not seen before)
          if (!uniqueRows.has(rows[i])) {
            // Add the row to the uniqueRows Set
            uniqueRows.add(rows[i]);

            // Split the row into columns
            const columns = rows[i].split(',');

            // Iterate through each column in the row
            for (let j = 0; j < columns.length; j++) {
              // Replace null or undefined with an empty string
              if (
                columns[j] === 'null' ||
                columns[j] === 'undefined' ||
                columns[j] === 'NaN'
              ) {
                columns[j] = '';
              }
            }

            // Join the columns back into a row
            filteredRows.push(columns.join(','));
          }
        }

        // Join the filtered rows back into a CSV string
        const updatedCSV = filteredRows.join('\n');

        // Create the download link with the updated CSV data
        const a = document.createElement('a');
        a.href = 'data:text/csv,' + updatedCSV;
        let filename = 'itemsCatalog';
        a.setAttribute('download', filename + '.csv');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    this.subscriptions.push(getDownloadcvsCatalogSubs);
  }

  visiblePages(): (number | string)[] {
    const currentPage = this.newItemsData?.currentPage || 1;
    const totalPages = this.newItemsData?.totalPages || 1;

    const visiblePages: (number | string)[] = [];

    // Always display the first page
    visiblePages.push(1);

    if (totalPages > 1) {
      // Display the pages based on the current page
      if (currentPage <= 5) {
        // Display the next 9 pages and ellipsis if needed
        const endPage = Math.min(10, totalPages);

        for (let i = 2; i <= endPage; i++) {
          visiblePages.push(i);
        }

        if (endPage < totalPages - 1) {
          visiblePages.push('...');
          visiblePages.push(totalPages);
        }
      } else {
        const endPage = Math.min(currentPage + 7, totalPages);

        visiblePages.push('...');

        for (let i = currentPage - 3; i <= endPage; i++) {
          visiblePages.push(i);
        }

        if (endPage < totalPages - 1) {
          visiblePages.push('...');
          visiblePages.push(totalPages);
        }
      }
    }

    return visiblePages;
  }
}
